import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchPost, objectify } from '../../utils';

export const fetch = async (query: { Supplier: number; Page: number; filters: any; Sort: string; SortDirection: string; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { Supplier, Page, filters, Sort, SortDirection, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchPost(
    `/SupplierEnquiry/PurchasingProducts/Supplier/${Supplier}/Retrieve`,
    filters
    &&
    {
      ...filters,
    },
    {
      BatchPage: Page, BatchSize, Sort: Sort && SortDirection && `${Sort}:${SortDirection}`
    },
    respType)
    .then(
      (result: {
        SupplierPurchasingProducts: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.SupplierPurchasingProducts) {

            return {
              records: result.SupplierPurchasingProducts.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
